import React, { useContext } from "react"
import VerticalLayout from "../VerticalLayout/index"
import TableList from "../TableList/TableListUsers"
import { AdminContext } from "./AdminContext"

const AdminList = () => {
  const AdminModel = useContext(AdminContext)
  const { UserTableTitle, adminData,getAdminList ,   nextPage,
    totalPagesCount,
    pageNumberThreshold,} = AdminModel

  return (
    <VerticalLayout>
      <div style={{ marginTop: "70px" }}>
        <TableList
          navLocation={"/details/adminId?="}
          title={"Admins"}
          titleList={UserTableTitle?.titles}
          tableData={adminData}
          userType={"Admin"}
          getAdminList={getAdminList}
          nextPage={nextPage}
          totalPagesCount={totalPagesCount}
          pageNumberThreshold={pageNumberThreshold}
        />
      
      </div>
    </VerticalLayout>
  )
}

export default AdminList
